import React from "react";
import api from "../../lib/api";
import { FileText } from "lucide-react";

export default function AdminAuditLog() {
    const [items, setItems] = React.useState([]);
    const [targetType, setTargetType] = React.useState("");

    React.useEffect(() => {
        const q = targetType ? `?target_type=${targetType}` : "";
        api.get("/admin/audit-log" + q).then(r => setItems(r.data || []));
    }, [targetType]);

    return (
        <div data-testid="admin-audit-log">
            <div className="overline mb-1">Administrare</div>
            <h1 className="font-heading text-3xl mb-2 flex items-center gap-3"><FileText className="h-7 w-7 text-primary" /> Audit log</h1>
            <p className="text-sm text-muted-foreground mb-4">Istoric modificări făcute de staff.</p>

            <div className="card-soft p-3 mb-4 flex gap-2">
                <select value={targetType} onChange={(e) => setTargetType(e.target.value)} className="input-soft !py-2" data-testid="audit-type-filter">
                    <option value="">Toate tipurile</option>
                    {["order", "product", "ticket", "appointment", "service", "user", "category", "package", "discount", "settings", "theme", "products"].map(t => <option key={t} value={t}>{t}</option>)}
                </select>
                <div className="text-xs text-muted-foreground self-center ml-auto">{items.length} evenimente</div>
            </div>

            <div className="card-soft overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-muted"><tr>{["Data/Ora", "Utilizator", "Acțiune", "Obiect", "ID", "Diff"].map(h => <th key={h} className="text-left px-3 py-3 text-xs uppercase text-muted-foreground">{h}</th>)}</tr></thead>
                    <tbody>
                        {items.length === 0 && <tr><td colSpan="6" className="text-center py-8 text-muted-foreground">Niciun eveniment.</td></tr>}
                        {items.map((it) => (
                            <tr key={it.log_id} className="border-t border-border">
                                <td className="px-3 py-2 text-xs font-mono">{new Date(it.at).toLocaleString("ro-RO")}</td>
                                <td className="px-3 py-2 text-xs">{it.user_name || "—"}<br /><span className="text-muted-foreground">{it.user_email}</span></td>
                                <td className="px-3 py-2"><span className="chip text-[10px] bg-primary/10 text-primary">{it.action}</span></td>
                                <td className="px-3 py-2 text-xs">{it.target_type}</td>
                                <td className="px-3 py-2 text-xs font-mono">{(it.target_id || "").slice(-10) || "—"}</td>
                                <td className="px-3 py-2 text-xs text-muted-foreground max-w-xs truncate">{JSON.stringify(it.diff || {})}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
